import { render, staticRenderFns } from "./businessRisk.vue?vue&type=template&id=77ed3468&scoped=true"
import script from "./businessRisk.vue?vue&type=script&lang=js"
export * from "./businessRisk.vue?vue&type=script&lang=js"
import style0 from "./businessRisk.vue?vue&type=style&index=0&id=77ed3468&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ed3468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ed3468')) {
      api.createRecord('77ed3468', component.options)
    } else {
      api.reload('77ed3468', component.options)
    }
    module.hot.accept("./businessRisk.vue?vue&type=template&id=77ed3468&scoped=true", function () {
      api.rerender('77ed3468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/businessRisk.vue"
export default component.exports